import React from 'react';
import InputText from './InputText';
import InputTextArea from './InputTextArea';
import InputModal from './InputModal';

const Input = (props) => {
  switch (props.type) {
    case 'textarea':
      return <InputTextArea {...props} />;
    case 'modal':
      return <InputModal {...props} />;
    default:
      return <InputText {...props} />;
  }
};

export default Input;
